import { render, staticRenderFns } from "./auction.vue?vue&type=template&id=8a059ca8&scoped=true"
import script from "./auction.vue?vue&type=script&lang=js"
export * from "./auction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a059ca8",
  null
  
)

export default component.exports